(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_upsell-product-card"] && !Shopify.designMode) return;
  try {
    // Update displayed price when variant is changed
  document.addEventListener('change', function (e) {
    const select = e.target.closest('[data-upsell-price-target]');
    if (!select) return;
    const selected = select.options[select.selectedIndex];
    const price = selected?.dataset.price;
    const targetId = select.dataset.upsellPriceTarget;
    if (!price || !targetId) return;
    const priceEl = document.querySelector(`[data-upsell-price="${targetId}"]`);
    if (priceEl) priceEl.textContent = price;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion-metafield"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function(event) {
    if (!event.target.matches('details') || !event.target.open) return;
    var accordion = event.target.closest('[data-accordion-exclusive]');
    if (!accordion) return;
    accordion.querySelectorAll('details[open]').forEach(function(details) {
      if (details !== event.target) details.removeAttribute('open');
    });
  }, true);
  } catch(e) { console.error(e); }
})();

})();
